import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import AppDatagridTable from '../../../layouts/AppDatagridTable';

import { useDispatch, useSelector } from 'react-redux';
import { getPageContent, submitForm } from '../../../../store/actions/ProductActions';
import AppLoader from '../../../pages/AppLoader';
import { ordersTable } from '../../../../utils/tableElements';
import moment from 'moment';
import { convertTo12HourFormat } from '../../../../utils/appConstants';

const OrderManagement = () => {
  const dispatch = useDispatch();

  const allProducts = useSelector(state => state?.products?.allProducts);
  const token = useSelector(state => state?.auth?.token);
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const orders = useSelector(state => state?.admin?.orders);

  const [tableData, setTableData] = useState({});

  useEffect(() => {
    dispatch(getPageContent('getAdminOrders', token));
  }, []);

  useEffect(() => {
    if (orders) {
      const modifiedRows = orders?.map(o => ({
        ...o,
        orderedByName: `${o?.billingAddress?.firstName} `,
        orderedOn: moment(o?.orderedOn).format('DD/MM/YYYY hh:mm A'),
        expectedDeliveryDate: o?.expectedDeliveryDate
          ? moment(o?.expectedDeliveryDate).format('DD/MM/YYYY')
          : '',
        'Town/City': o?.billingAddress?.['Town/City'],
        deliveryTimeSlots: o?.deliveryTimeSlots?.[0]
          ? `${convertTo12HourFormat(o?.deliveryTimeSlots[0])} - ${convertTo12HourFormat(
              o?.deliveryTimeSlots[1]
            )}`
          : '',
        orderedItems: o?.products?.length,
      }));

      setTableData({ columns: ordersTable, rows: modifiedRows });
    }
  }, [orders]);

  return orders ? (
    <div>
      <AppTitle title={'Orders'} from='Home' to='Orders' link='/' />

      <div className='mx-4 my-8'>
        <AppDatagridTable tableData={tableData} />
      </div>
    </div>
  ) : (
    <AppLoader />
  );
};

export default OrderManagement;
